/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, {  useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
    Input,
    Button,
} from '@material-ui/core';
import IconClose from '@material-ui/icons/Close';
import {
    object, func, string, bool, shape,
} from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import GraphqlWineRestrictions from './GraphqlWineRestrictions';
import DateOfBirthContainer from './DateOfBirthContainer';
import { getIsProductFilterZipcodeValid } from '../../../../../../../state/ducks/App/App-Selectors';
import { trackEvent } from '../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

const styles = (theme) => ({
    mobileModal: {
        padding: '20px',
        '& .top-content': {
            textAlign: 'center',
        },
        '& .verification-container': {
            margin: '0 auto',
            maxWidth: 240,
        },
        '& .input-field': {
            minHeight: 85,
        },
        '& .zip-code-label': {
            margin: 0,
        },
        '& .zip-code-box': {
            paddingTop: 15,
        },
        '& .age-verification::after': {
            left: 30,
            top: 0,
        },
        '& .age-verification.success::after': {
            padding: 5,
        },
        '& .age-verification.success::before': {
            top: -15,
        },
        '& .zip-code-success::after': {
            right: 15,
        },
        '& .zip-code-success': {
            '&::before': {
                top: -30,
                right: 75,
            },
        },
        '& .zip-code-error': {
            '&::after': {
                top: -7,
                right: 30,
            },
        },
        '& p': {
            margin: '10px',
        },
    },
    addonBox: {
        '& .age-verification': {
            position: 'relative',
        },
        '& .age-verification::after': {
            left: 28,
            top: -10,
        },
        '& .zip-code-box': {
            paddingTop: 0,
        },
    },
    icon: {
        color: theme.palette.colorIconHeader,
        height: '40px',
        textAlign: 'right',
    },
    topContent: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    main: {
        width: '633px',
        height: '230px',
        margin: '0px 0px 18px 0px',
    },
    cardTitleZipCode: {
        fontSize: '16px',
        fontWeight: '700',
        margin: '31px 0px 8px 0px',
    },
    textField: {
        minHeight: '45px',
        margin: '0px 0px 0px 15px',
        '& .MuiFormHelperText-root': {
            fontSize: '9px',
        },
        '& .MuiInputBase-root': {
            display: 'block',
        },
        '& .MuiInputBase-input': {
            padding: '9px 0',
            textAlign: 'center',
        },
    },
    verificationContainer: {
        display: 'block !important',
    },
    zipcode: {
        width: '100%',
        paddingTop: '40px',
        '& .MuiInputBase-input': {
            width: '68px',
            height: '29px',
            border: `1px solid ${theme.palette.cms?.wineVerifyDisable || '#b9b8b8'}`,
            backgroundColor: theme.palette.cms?.white || '#ffffff',
            '&:disabled': {
                backgroundColor: theme.palette.cms?.wineVerifyDisable || '#b9b8b8',
            },
        },
        '& .zip-code-error': {
            '&::before': {
                top: 0,
            },
        },
    },
    form: {
        width: '150px',
        margin: '8px 0px 0px 0px',
        '& .MuiButton-root.Mui-disabled': {
            backgroundColor: theme.palette.cms?.grey || '#b9b8b8',
            color: theme.palette.cms?.white || '#ffffff',
            border: 'inherit',
        },
    },

    zipField: {
        textAlign: 'center',
    },
    additionalCompliance: {
        backgroundColor: theme.palette.cms?.additionalComplianceColor || '#f9f6f6',
        color: theme.palette.black || '#1f1f1b',
        padding: '5px',
        fontSize: '0.8em',
        lineHeight: '1.4em',
        '& p': {
            margin: '10px',
        },
    },
    complianceLink: {
        color: theme.palette.black || '#1f1f1b',
        background: 'transparent',
        border: '0',
        padding: '0',
        textDecoration: 'underline',
        cursor: 'pointer',
    },
    dialogMain: {
        position: 'relative',
    },
    wineContainer: {
        padding: '0 10px',
        fontSize: '0.8em',
        minHeight: '120px',
        minWidth: '300px',
        '& h4': {
            fontSize: '1.2em',
        },
        '& h5': {
            fontSize: '1em',
        },
        '& h6': {
            fontSize: '1em',
        },
    },
    wineHeader: {
        display: 'inline-block',
    },
    wineHeaderClose: {
        display: 'inline-block',
        right: '10px',
        top: '3px',
        position: 'absolute',
        backgroundColor: theme.palette.white || '#ffffff',
        cursor: 'pointer',
    },
    zipSubmitButton: {
        backgroundColor: theme.palette.primary.main || '#2F2F2F',
        color: theme.palette.cms?.white || '#ffffff',
        minWidth: 'auto',
        padding: '0px 15px',
        borderRadius: 'inherit',
        marginTop: '3px',
        height: '37px',
        marginLeft: '10px',
        '&:hover': {
            backgroundColor: theme.palette.primary.main || '#2F2F2F',
        },

    },
    zipCodeLink: {
        textDecoration: 'underline',
        fontWeight: 500,
        color: '#000000',
        fontSize: '18px',
        marginTop: '5px',
        display: 'block',
    },
});

const AgeVerificationRecipientForm = ({
    classes,
    oncloseDrawer,
    getBirthMonth,
    validateFields,
    birthMonth,
    monthErrorMessage,
    getBirthDay,
    birthDay,
    dayErrorMessage,
    getBirthYear,
    birthYear,
    yearErrorMessage,
    handleAgeVerification,
    handleZipChange,
    zipField,
    zipFieldRef,
    isModal,
    wineContainerRef,
    isDrawer,
    selectedItem,
    inlinePDPAddon,
    recipientDayErrorMessage,
    recipientYearErrorMessage,
    recipientBirthDay,
    recipientBirthMonth,
    recipientBirthYear,
    recipientMonthErrorMessage,
    stateValue,
}) => {
    const [triggerRestrictions, showWineShippingDetails] = useState(false);
    const [open, setOpen] = useState(false);
    const zipValid = useSelector(getIsProductFilterZipcodeValid);
    useEffect(() => {
        if (wineContainerRef.current && wineContainerRef.current.scrollIntoView) {
            wineContainerRef.current.scrollIntoView({
                top: 0,
                left: 0,
                behavior: 'smooth',
            });
        }
    }, [triggerRestrictions]);
    const dispatch = useDispatch();
    useEffect(() => {
        if (stateValue === 'HI' || stateValue === 'WI') {
            dispatch(trackEvent({
                eventCategory: 'Wine- HI/WI',
                eventAction: 'DOB Recipient Requirement',
                eventLabel: 'Age Verification Modal',
            }));
        }
    }, [stateValue]);
    return (
        (isModal || isDrawer) && !triggerRestrictions ? (
            <>
                <div className={isModal ? classes.mobileModal : classes.addonBox}>
                    <div className={`top-content ${classes.topContent}`}>
                        <h3>Confirm Your Age and Destination For Wine Purchase</h3>
                        {!isModal && (
                            <div
                                className={classes.iconHeader}
                                onClick={() => oncloseDrawer(false)}
                                onKeyDown={() => { }}
                                role="button"
                                tabIndex={-1}
                            >
                                <IconClose className={classes.icon} />
                            </div>
                        )}
                    </div>
                    <p className={classes.ageVerificationSummary}>
                        I swear or affirm that: a) I am 21 years of age or older; b) my purchase of wine products is intended for personal consumption and not for resale; and c) the person receiving wine products is 21 years of age or older and will provide proof of age with valid identification and signature upon delivery.
                    </p>
                    <div className={`verification-container ${classes.verificationContainer}`} data-testid="age-verification-model">

                        <div className={`zip-code-box ${classes.zipcode}`}>
                            <p className={`zip-code-label ${classes.cardTitleZipCode}`}>
                                Enter Destination ZIP code
                            </p>
                            <div className={classes.label}>Zip Code</div>
                            {!open && zipField?.length <= 5 ? (
                                <div className={classes.form} style={{ display: 'flex' }}>
                                    <Input
                                        className={classes.zipField}
                                        type="tel"
                                        margin="normal"
                                        id="zipcode-text-field"
                                        data-test="pdp-zipcode-text-field"
                                        name="zipcodeTextField"
                                        onChange={(e) => handleZipChange(e, 'recipient')}
                                        value={zipField}
                                        inputRef={zipFieldRef}
                                        inputProps={{
                                            'data-testid': 'zip-code-field',
                                            maxLength: 5,
                                            className: classes.zipField,
                                        }}
                                    />
                                    <Button
                                        className={`${classes.zipSubmitButton}`}
                                        disabled={!zipValid || zipField?.length < 5}
                                        onClick={() => {
                                            setOpen(true);
                                        }}
                                        data-testId="submit"
                                    >
                                        submit
                                    </Button>
                                </div>
                            ) :  (
                                <Button
                                    type="button"
                                    onClick={() => {
                                        setOpen(false);
                                    }}
                                    className={classes.zipCodeLink}
                                    style={{

                                        textDecoration: 'underline',

                                    }}
                                >
                                    {zipField}
                                </Button>
                            )}
                        </div>
                        {open && zipValid &&  (
                            <div>
                                <DateOfBirthContainer
                                    classes={classes}
                                    getBirthMonth={getBirthMonth}
                                    validateFields={validateFields}
                                    birthMonth={birthMonth}
                                    monthErrorMessage={monthErrorMessage}
                                    getBirthDay={getBirthDay}
                                    birthDay={birthDay}
                                    dayErrorMessage={dayErrorMessage}
                                    getBirthYear={getBirthYear}
                                    birthYear={birthYear}
                                    yearErrorMessage={yearErrorMessage}
                                    handleAgeVerification={() => handleAgeVerification('')}
                                    zipFieldRef={zipFieldRef}
                                    inlinePDPAddon={inlinePDPAddon}
                                    label="Enter Your Date Of Birth"
                                />
                                {(stateValue === 'HI' || stateValue === 'WI') && (
                                    <DateOfBirthContainer
                                        classes={classes}
                                        getBirthMonth={(e) => getBirthMonth(e, 'recipient')}
                                        getBirthDay={(e) => getBirthDay(e, 'recipient')}
                                        getBirthYear={(e) => getBirthYear(e, 'recipient')}
                                        validateFields={(e) => validateFields(e, '', 'recipient')}
                                        birthMonth={recipientBirthMonth}
                                        birthDay={recipientBirthDay}
                                        birthYear={recipientBirthYear}
                                        monthErrorMessage={recipientMonthErrorMessage}
                                        dayErrorMessage={recipientDayErrorMessage}
                                        yearErrorMessage={recipientYearErrorMessage}
                                        handleAgeVerification={() => handleAgeVerification('recipient')}
                                        zipFieldRef={zipFieldRef}
                                        inlinePDPAddon={inlinePDPAddon}
                                        label="Enter Recipient Date Of Birth"
                                        type="recipient"
                                    />
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </>
        ) : (
            <div className={classes.wineContainer} data-testid="wine-shipping-details">
                <h4 className={classes.wineHeader}>WINE SHIPPING DETAILS</h4>
                <div className={classes.wineHeaderClose} role="presentation" onClick={() => { showWineShippingDetails(false); }}>
                    <IconClose className={classes.icon} />
                </div>
                <GraphqlWineRestrictions brandId={selectedItem.brandId} path="/h/view/wineship" />
            </div>
        )
    );
};

AgeVerificationRecipientForm.defaultProps = {
    isModal: false,
    isDrawer: false,
    wineContainerRef: {},
    inlinePDPAddon: false,
    stateValue: '',
};
AgeVerificationRecipientForm.propTypes = {
    classes: object.isRequired,
    selectedItem: shape({
        brandId: string.isRequired,
    }).isRequired,
    zipField: string.isRequired,
    birthDay: string.isRequired,
    birthMonth: string.isRequired,
    birthYear: string.isRequired,
    dayErrorMessage: string.isRequired,
    monthErrorMessage: string.isRequired,
    yearErrorMessage: string.isRequired,
    zipFieldRef: func.isRequired,
    getBirthDay: func.isRequired,
    getBirthMonth: func.isRequired,
    getBirthYear: func.isRequired,
    handleAgeVerification: func.isRequired,
    validateFields: func.isRequired,
    handleZipChange: func.isRequired,
    oncloseDrawer: func.isRequired,
    isModal: bool,
    isDrawer: bool,
    inlinePDPAddon: bool,
    wineContainerRef: object,
    recipientDayErrorMessage: string.isRequired,
    recipientYearErrorMessage: string.isRequired,
    recipientBirthDay: string.isRequired,
    recipientBirthMonth: string.isRequired,
    recipientBirthYear: string.isRequired,
    recipientMonthErrorMessage: string.isRequired,
    stateValue: string,
};

export default withStyles(styles)(AgeVerificationRecipientForm);
